import {autobind} from 'core-decorators';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {Tooltip} from '../components';
import dialog from '../dialog';


export class FlagIcon extends Component<jsx.Props, jsx.State> {
    @autobind
    handleClick(event: Event) {
        dialog.open('flagging');
    }

    render() {
        const gettextSub = this.context.gtService.gettextSub;
        // Translators: alt img text for a flag icon. This icon is used to
        // Translators: allow users to flag content as being inappropriate.
        const altText = gettextSub('flag icon');
        return (
            <span className="FlagIcon" onClick={this.handleClick}>
                <Tooltip
                    hoverMsg={gettextSub('Report')}
                />
                <img
                    src={`/assets/img/icons/flag.svg`}
                    alt={altText}
                />
            </span>
        );
    }
}
